/* Testimonials lightbox
   ----------------------------------------------------------------------
   Compact 16:9 thumbnails (.testimonial__thumb) open a shared native
   <dialog> that plays the full video. Each thumbnail carries ONE source:
     data-video-src   — a Shopify/local MP4 URL  → <video controls autoplay>
     data-youtube-id  — a YouTube video id        → privacy-enhanced <iframe>
   If neither is set yet, the dialog shows a placeholder note so the
   click-to-enlarge interaction is still demonstrable in the prototype.

   On open we BUILD the media element; on close we REMOVE it — that's what
   stops playback (and unloads the YouTube iframe). Native <dialog> gives us
   Esc-to-close, the backdrop, focus trapping and focus restore for free.

   Shopify port: markup/behaviour are unchanged; the theme just renders the
   data-* attributes (data-video-src from a section `video`/`video_url`
   block, data-poster from its preview image). */
(function () {
  var dialog = document.querySelector('[data-testimonial-dialog]');
  var triggers = document.querySelectorAll('[data-testimonial]');
  if (!dialog || !triggers.length) return;

  var stage = dialog.querySelector('[data-stage]');

  function buildMedia(trigger) {
    var src = (trigger.getAttribute('data-video-src') || '').trim();
    var yt = (trigger.getAttribute('data-youtube-id') || '').trim();
    var poster = (trigger.getAttribute('data-poster') || '').trim();

    if (src) {
      var video = document.createElement('video');
      video.src = src;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      if (poster) video.poster = poster;
      return video;
    }

    if (yt) {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + yt +
        '?autoplay=1&rel=0&modestbranding=1';
      iframe.title = trigger.getAttribute('data-video-title') || 'Testimonial video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.setAttribute('allowfullscreen', '');
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      return iframe;
    }

    // No source wired yet — show a placeholder so the interaction still works.
    var note = document.createElement('div');
    note.className = 'video-lightbox__placeholder';
    note.innerHTML = '<strong>' +
      (trigger.getAttribute('data-video-title') || 'Testimonial video') +
      '</strong><span>The full video will play here once it’s added.</span>';
    return note;
  }

  function openFrom(trigger) {
    clearStage();
    stage.appendChild(buildMedia(trigger));
    dialog.__opener = trigger;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', ''); // very old fallback
    }
  }

  function clearStage() {
    var video = stage.querySelector('video');
    if (video) { try { video.pause(); } catch (e) {} video.removeAttribute('src'); }
    stage.textContent = '';
  }

  function close() {
    if (dialog.open && typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  triggers.forEach(function (trigger) {
    var poster = (trigger.getAttribute('data-poster') || '').trim();
    var hasSource = ((trigger.getAttribute('data-video-src') || '') +
      (trigger.getAttribute('data-youtube-id') || '')).trim();

    // If a poster is provided, show it as the thumbnail image.
    if (poster && !trigger.querySelector('.testimonial__poster')) {
      var img = document.createElement('img');
      img.className = 'testimonial__poster';
      img.src = poster;
      img.alt = '';
      img.loading = 'lazy';
      trigger.insertBefore(img, trigger.firstChild);
    }

    // A wired card (has a poster or a source) sheds the dashed placeholder look.
    if (poster || hasSource) trigger.classList.remove('slot__box');

    trigger.addEventListener('click', function () { openFrom(trigger); });
  });

  // Close button
  var closeBtn = dialog.querySelector('[data-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);

  // Click on the backdrop (the dialog element itself, outside its inner box)
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) close();
  });

  // Esc (dialog fires 'cancel') and any close: tear down the media + restore focus
  dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  dialog.addEventListener('close', function () {
    clearStage();
    var opener = dialog.__opener;
    if (opener && typeof opener.focus === 'function') opener.focus();
  });
})();
